import {SET_SITE_VALUES, SET_SOCIAL_SHARING} from '../actions/action-types';

const CHINA = 'CN';

export const initialState = {
  socialChannels: [],
  inwardReferralUrl: '',
  inwardSiteUrl: '',
  customerCredit: '',
  numReferrals: undefined,
  isSocialSharingRestricted: false,
};

const socialSharingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SOCIAL_SHARING:
      return {...state, ...action.values};
    case SET_SITE_VALUES:
      return {...state, isSocialSharingRestricted: action.values.userLocation === CHINA};
    default:
      return state;
  }
};

export default socialSharingReducer;
